<div class="cc-footer" *ngrxLet="isInStandaloneMode$ as isInStandaloneMode">
  <div class="cc-grid-container">
    <div class="cc-footer__texts">
      <cc-footer-disclaimer [whipeout]="disclaimerWhipeout$ | async" />
    </div>
  </div>
  <cc-footer-links *ngIf="isInStandaloneMode" />
</div>
